import { Controller } from "@hotwired/stimulus"

// Auto-submits the nav catalog import form as soon as a file is chosen
// (the file input itself is visually hidden behind a styled label/button),
// and swaps the button's label to the picked filename for feedback.
export default class extends Controller {
  static targets = ["input", "label"]

  submit() {
    const file = this.inputTarget.files[0]
    if (!file) return

    this.labelTarget.textContent = file.name
    this.inputTarget.form.requestSubmit()
  }
}
